import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { APP_SYSTEM_VERSION } from '@/constants/appSystemVersion'

export function setDatadogUser(user) {
  if (!user) return
  datadogRum.setUser({
    id: String(user.id),
    name: user.name,
    email: user.email
  })
}

// Opt-in explícito. O guard anterior era opt-out (desligava em development/
// local/test) e, por isso, qualquer ambiente novo ou secret ausente subia com
// RUM a 100% — foi assim que homolog passou a consumir a mesma franquia de
// produção.
//
// Três estados:
//   VITE_ENABLE_DATADOG=true   -> liga, em qualquer mode
//   VITE_ENABLE_DATADOG=false  -> desliga, mesmo em produção (kill switch)
//   ausente                    -> liga só em produção
const mode = import.meta.env.MODE
const enableFlag = String(
  import.meta.env.VITE_ENABLE_DATADOG || ''
).toLowerCase()
const isDatadogEnabled =
  enableFlag === 'true' || (enableFlag !== 'false' && mode === 'production')

if (isDatadogEnabled) {
  const apiUrl = import.meta.env.VITE_API_URL

  datadogRum.init({
    applicationId: '114210c7-dae5-4109-b023-13e8ff4ff6d4',
    clientToken: 'pubcac2d74e842406cc81ad73a4ebe62dc6',
    site: 'datadoghq.com',
    service: 'eyecarebi',
    env: mode,
    version: import.meta.env.VITE_APP_VERSION || APP_SYSTEM_VERSION,
    // Taxas alinhadas à franquia contratada. Alterar qualquer uma delas tem
    // impacto direto na fatura — ver docs/datadog/ no eyecarebi-backend.
    sessionSampleRate: 20,
    // Percentual DAS SESSÕES JÁ AMOSTRADAS: 20% x 10% = 2% do total.
    sessionReplaySampleRate: 10,
    // Mantém coerência com DD_TRACE_SAMPLE_RATE=0.1 no backend.
    traceSampleRate: 10,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: apiUrl
      ? [
          {
            match: url => url.includes(apiUrl),
            propagatorTypes: ['datadog', 'tracecontext']
          }
        ]
      : []
  })

  datadogLogs.init({
    clientToken: 'pubcac2d74e842406cc81ad73a4ebe62dc6',
    site: 'datadoghq.com',
    service: 'eyecarebi',
    env: mode,
    version: import.meta.env.VITE_APP_VERSION || APP_SYSTEM_VERSION,
    forwardErrorsToLogs: true,
    // Vue 2 emite muito console.warn de prop/deprecation — só erros.
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 20
  })
}
